import { render, staticRenderFns } from "./unknowPage.vue?vue&type=template&id=0e3c651c&scoped=true&"
import script from "./unknowPage.vue?vue&type=script&lang=js&"
export * from "./unknowPage.vue?vue&type=script&lang=js&"
import style0 from "./unknowPage.vue?vue&type=style&index=0&id=0e3c651c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3c651c",
  null
  
)

export default component.exports